export const AutoComplete = {
  USERNAME: 'username',
  COUNTRY: 'country',
  CURRENTPASSWORD: 'current-password',
  EMAIL: 'email',
  FAMILYNAME: 'family-name',
  GIVENNAME: 'given-name',
  NEWPASSWORD: 'new-password',
  TEL: 'tel',
} as const;
